import debug from 'debug';
import { login, validateSellerAuthorization } from './User';
import { get, post, login as loginRequest, logout as logoutRequest, getToken as _getToken } from './fetch';

export const loginSeller = async (email, password) => {

    try {
        let authRes = await login(email, password)
        if (authRes.resStatus == 200) {
            let validRes = await validateSellerAuthorization();
            if (validRes.resStatus == 200) {
                return { data: validRes.data.user, error: null }
            } else if (validRes.resStatus >= 400) {
                return { error: validRes.message || "Error while login" };
            }
        } else if (authRes.resStatus >= 400) {
            return { error: authRes.message || "Error while login" };
        }
    } catch (error) {
        console.log(error);
    }



    // .then((authRes) => {
    //     if (authRes.resStatus == 200) {
    //         return validateSellerAuthorization().then((validRes) => {               
    //             if (validRes.resStatus == 200) {
    //                 return { data: validRes.data.user, error: null }
    //             } else if (validRes.resStatus >= 400) {
    //                 return { error: "Error while login" }
    //             }
    //         })
    //     } else if (authRes.resStatus >= 400) {
    //         return { error: "Error while login" }
    //     }
    // });
}